
<div>
  <div v-if="isLoadingTemplate" class="d-flex justify-content-center align-items-center" style="height: 500px;">
    <v-progress-circular indeterminate color="primary" />
  </div>
  <v-data-table class="table-template" v-else hide-default-footer item-key="id" :headers="headers" :items="items"
    :items-per-page="perPage" no-data-text="No scheduled reports found" fixed-header hide-default-header>
    <template v-slot:header="{ props: { headers } }">
      <tr>
        <th v-for="(header, index) in headers" :key="index"
          :class="{ 'th-no-wrap': ['created_by', 'template_name', 'created_at'].includes(header.value) }"
          :style="headerStyle(header.value)">
          {{ header.text }}
        </th>
      </tr>
    </template>
    <template v-slot:item.name="{ item }">
      <td class="border-bottom-0 pl-0" :style="columnStyle('name')">
        <a
          :href="`/dashboard/scheduled_report/${item.id}`"
          :title="item.name || ''"
          class="schedule-name-link"
        >
          {{ item.name ? item.name : '-' }}
        </a>
      </td>
    </template>

    <template v-slot:item.template_name="{ item }">
      <td class="border-bottom-0 pl-0" :style="columnStyle('template_name')">
        <span class="schedule-cell-text-wrap" :title="item.template_name || ''">{{ item.template_name || '-' }}</span>
      </td>
    </template>

    <template v-slot:item.category="{ item }">
      <td class="border-bottom-0 pl-0" :style="columnStyle('category')">
        <span class="schedule-cell-text" :title="item.category || ''">{{ item.category || '-' }}</span>
      </td>
    </template>

    <template v-slot:item.recipient="{ item }">
      <td class="border-bottom-0 pl-0" :style="columnStyle('recipient')">
        <div class="d-flex align-items-center">
          <span class="schedule-recipient-text">
            <template v-if="firstRecipient(item)">
              <span>{{ firstRecipient(item).email }}</span>
              <span v-if="isRecipientInactive(firstRecipient(item))" class="recipient-inactive-label">(Inactive)</span>
            </template>
            <template v-else>-</template>
          </span>
          <RecipientTooltip v-if="moreRecipients(item).length > 0" :hoverMode="true" direction="bottom" :nudge="-5">
            <template #trigger>
              <span class="text-primary ml-1">+{{ moreRecipients(item).length }} more</span>
            </template>
            <template #text>
              <div class="recipient-tooltip">
                <div v-for="(recipient, idx) in moreRecipients(item)" :key="idx" class="recipient-tooltip__item">
                  <span class="recipient-tooltip__email">{{ recipient.email }}</span>
                  <span v-if="isRecipientInactive(recipient)" class="recipient-inactive-label">(Inactive)</span>
                </div>
              </div>
            </template>
          </RecipientTooltip>
        </div>
      </td>
    </template>

    <template v-slot:item.frequency="{ item }">
      <td class="border-bottom-0 pl-0" :style="columnStyle('frequency')">
        <span style="color: #3F3F3F;">{{ item.frequency || '-' }}</span>
      </td>
    </template>

    <template v-slot:item.created_by="{ item }">
      <td class="border-bottom-0 pl-0" :style="columnStyle('created_by')">
        <div class="d-flex justify-content-center align-items-center" style="gap: 8px;">
          <CSquareAvatar :user="item.created_by" :size="28"></CSquareAvatar>
        </div>
      </td>
    </template>

    <template v-slot:item.status="{ item }">
      <td class="border-bottom-0 pl-0" :style="columnStyle('status')">
        <StatusBadge
          v-if="item.status"
          type="clients"
          :status="item.status.toString().toLowerCase()"
        />
        <span v-else>-</span>
      </td>
    </template>

    <template v-slot:item.created_at="{ item }">
      <td class="border-bottom-0 pl-0" :style="columnStyle('created_at')">
        <span class="schedule-cell-text">{{ formatShortDate(item.created_at) }}</span>
      </td>
    </template>

    <template v-slot:item.action="{ item }">
      <td class="border-bottom-0 pl-0" :style="columnStyle('action')">
        <div class="schedule-action-row d-flex" style="gap: 8px; float: right;">
          <button @click="runReport(item)" class="btn btn-outline-primary btn-sm schedule-action-btn">
            Run Report
          </button>
          <button @click="viewScheduledReport(item.id)" class="btn btn-primary btn-sm schedule-action-btn">
            Preview
          </button>
          <!-- v-menu with trigger button -->
          <v-menu content-class="schedule-action-menu" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <button v-bind="attrs" v-on="on" style="border:1px solid #D7D7D7" class="btn btn-outline btn-sm schedule-action-btn">
                <span class="mdi mdi-dots-horizontal"></span>
              </button>
            </template>
            <div>
              <div class="schedule-action-item" @click="toggleStatus(item)">
                <span class="schedule-action-title">{{ toggleLabel(item.status) }}</span>
              </div>
            </div>
          </v-menu>
        </div>
      </td>
    </template>
  </v-data-table>
  <TablePagination v-if="totalItems > 0" @loadData="loadData" @loadPerPage="loadPerPage" :perPage="perPage"
    :totalItems="totalItems" showDropdownPerPage title="report template(s)" />
</div>
